import React from 'react';

const AWS_EC2_Intro = () => {
  return (
    <div>
      <h1>AWS_EC2_Intro</h1>
      <p>This is the AWS_EC2_Intro component.</p>
    </div>
  );
};

export default AWS_EC2_Intro;
